module.exports = new __parcel__URL__("aic_lab_level_3.9be40822.png").toString();